import { View } from '@play-co/timestep-core/ui';
import * as config from './uiConfig';
import { DescriptiveScript } from 'src/replicant/conversation/conservation.ruleset';
import StateObserver from 'src/StateObserver';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import { Conversation } from 'src/replicant/conversation';
import PopupBasic from 'src/game/components/popups/PopupBasic';
import sounds from 'src/lib/sounds';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { TextInput } from '../shared/TextInput';
import platform from '@play-co/gcinstant';
import { getPlayerIdFromConversation } from 'src/game/conversation/conversation.redux';

type CloseHandler = (answer?: string) => void;

export default class PopupDescriptiveScript extends PopupBasic {
  private close: CloseHandler;
  private maxLength: LangBitmapFontTextView;
  private inputView: TextInput;
  private buttonOkay: ButtonScaleViewWithText;

  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      ...opts,
      ...config.descriptive.popup,
      boxOpts: config.box,
      tracking: { feature: 'conversation', $subFeature: 'descriptive' },
    });
    this.close = opts.close;

    this.bg.updateOpts(config.bg);
    this.buttonClose.removeFromSuperview();
    this.message.updateOpts(config.descriptive.message);

    this.maxLength = new LangBitmapFontTextView({
      ...config.descriptive.maxLength,
      superview: this.box,
    });

    this.inputView = new TextInput({
      tag: 'textinput',
      superview: this.box,
      ...config.descriptive.input,
    });

    this.buttonOkay = new ButtonScaleViewWithText({
      ...config.descriptive.button,
      superview: this.box,
      localeText: () => i18n('basic.okay'),
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close(
          this.inputView.input.value ?? this.inputView.input.placeholder,
        );
      },
    });
    this.buttonOkay.setDisabled(true);
  }

  init({ id, max_len, move_to }: DescriptiveScript) {
    const { user, ui, conversation } = StateObserver.getState();

    super.init({
      id,
      move_to,
      message: Conversation.getters(user).getScriptQuestion(
        id,
        ui.locale,
        getPlayerIdFromConversation(id) !== platform.playerID,
      ),
    });

    this.maxLength.localeText = () =>
      i18n('conversation.maxLength', { maxLength: max_len });
    const { input } = this.inputView;

    this.inputView.updateOpts({ minLength: 1, maxLength: max_len });
    this.inputView.on('InputValidated', (valid) => {
      this.buttonOkay.setDisabled(!valid);
    });
  }
}
